import { z } from "zod";
import { MessageFieldsSchema } from "./Message";

export const MessageThreadFieldsSchema = z.object({
  id: z.number(),
  lastMessageContent: z.string(),
  lastMessageDate: z.string(),
  lastSenderName: z.string(),
  lastSenderAvatar: z.string(),
  isArchival: z.boolean(),
  userCount: z.number(),
  lastMessage: z.union([MessageFieldsSchema, z.any()]),
  users: z.any(),
  messages: z.any(),
  hasBeenRead: z.boolean(),
  relations: z.object({
    commissions: z.any(),
    documentOrders: z.any(),
    documentOfferQuestions: z.any(),
    documentInvoices: z.any(),
    tasks: z.any(),
    emailMessages: z.any(),
    servicedProducts: z.any(),
    products: z.any(),
    campaignOpportunities: z.any(),
  }),
});

export const PartialMessageThreadFieldsSchema =
  MessageThreadFieldsSchema.deepPartial();

export const MessageThreadExtraFieldsSchema = z.object({
  availableTemplates: z.array(z.number()),
  hasBeenRead: z.boolean(),
  notificationsEnabled: z.boolean(),
});

export const PartialMessageThreadExtraFieldsSchema =
  MessageThreadExtraFieldsSchema.deepPartial();

export const MessageThreadSchema = z.intersection(
  MessageThreadFieldsSchema,
  MessageThreadExtraFieldsSchema
);

export type MessageThreadFields = z.infer<typeof MessageThreadFieldsSchema>;
export type PartialMessageThreadFields = z.infer<
  typeof PartialMessageThreadFieldsSchema
>;
export type MessageThreadExtraFields = z.infer<
  typeof MessageThreadExtraFieldsSchema
>;
export type PartialMessageThreadExtraFields = z.infer<
  typeof PartialMessageThreadExtraFieldsSchema
>;

export type MessageThread = z.infer<typeof MessageThreadSchema>;
export type MessageThreadPartial = z.infer<
  typeof PartialMessageThreadFieldsSchema
>;
